import React, { useEffect, useState } from "react";
import { Table, Button, Input, Spinner, Col } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import useBuilders from "../../Hooks/useBuilders";
import BuilderModal from "../../Modal/Builders/BuilderModal";

const BuildersList = () => {
  const [filters, setFilters] = useState({
    search: "",
    page: 1,
    status: "active", 
    });

  const [modal, setModal] = useState(false);
  const [selected, setSelected] = useState(null);

  const { builders, loading, pagination, createBuilder, updateBuilder, deleteBuilder, reactivateBuilder, } = useBuilders(filters);
  useEffect(()=>{

    if(
      pagination.totalPages &&
      filters.page >
      pagination.totalPages
    ){

      setFilters((p)=>({
        ...p,
        page:pagination.totalPages,
      }));
    }

  },[
    pagination.totalPages,
  ]);

  return (
    <div className="page-content">
      <Breadcrumbs title="Builders" breadcrumbItem="All Builders" />

      {/* 🔹 SEARCH + ADD */}
      <div className="d-flex gap-2 mb-3">
        <Col md={4}>
          <Input
            placeholder="Search builders..."
            value={filters.search}
            onChange={(e) =>
              setFilters({
                ...filters,
                search: e.target.value,
                page: 1,
              })
            }
          />  
        </Col>
        <Col md={2}>
          <Input
              type="select"
              value={filters.status}
              onChange={(e) =>
                  setFilters({
                  ...filters,
                  status: e.target.value,
                  page: 1,
                  })
              }
              >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
          </Input>
        </Col>
        <Button
          color="success"
          onClick={() => {
            setSelected(null);
            setModal(true);
          }}
        >
          <i className="mdi mdi-plus" /> Add
        </Button>
      </div>

      {/* 🔹 TABLE */}
      <Table bordered hover responsive>
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th width="120">Actions</th>
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan="4" className="text-center">
                <Spinner size="sm" />
              </td>
            </tr>
          ) : builders.length === 0 ? (
            <tr>
              <td colSpan="4" className="text-center">
                No Builders Found
              </td>
            </tr>
          ) : (
            builders.map((b) => (
              <tr key={b._id}>
                <td>{b.name}</td>
                <td>{b.phone || "-"}</td>
                <td>{b.email || "-"}</td>

                <td>
                    {filters.status === "inactive" ? (
                        <i
                            className="mdi mdi-restore text-success"
                            style={{ cursor: "pointer", fontSize: 20 }}
                            onClick={() => reactivateBuilder(b._id)}
                        />
                        ) : (
                        <>
                            <i
                            className="mdi mdi-pencil text-primary"
                            style={{ cursor: "pointer", fontSize: 20 }}
                            onClick={() => {
                                setSelected(b);
                                setModal(true);
                            }}
                            />

                            <i
                            className="mdi mdi-delete text-danger"
                            style={{ cursor: "pointer", fontSize: 20 }}
                            onClick={() => deleteBuilder(b._id)}
                            />
                        </>
                        )}
                    </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      {/* 🔹 PAGINATION */}
      <div className="d-flex justify-content-end gap-2">
        <Button
          size="sm"
          disabled={filters.page <= 1}
          onClick={() =>
            setFilters({
              ...filters,
              page: filters.page - 1 < 1 ? 1 : filters.page - 1,
            })
          }
        >
          ◀
        </Button>

        <span>
          {filters.page} / {pagination.totalPages}
        </span>

        <Button
          size="sm"
          disabled={
            filters.page >= pagination.totalPages
          }
          onClick={() =>
            setFilters({
              ...filters,
              page: filters.page + 1 > pagination.totalPages ? pagination.totalPages : filters.page + 1,
            })
          }
        >
          ▶
        </Button>
      </div>

      {/* 🔹 MODAL */}
      <BuilderModal
        isOpen={modal}
        toggle={()=>{
          setModal(false);
          setSelected(null);
        }}
        selected={selected}
        onSave={selected ? updateBuilder : createBuilder}
      />
    </div>
  );
};

export default BuildersList;